<template>
  <div class="box" style="overflow: hidden">
    <div class="py-2">
      <div class="col-xs-12 col-md-12 pr-0 pl-0 mb-4" style="min-height: 100vh; max-height: 100vh; overflow-y: auto">
        <div>
          <div class="p-0">
            <span class="btn btn-first btn-md float-right mt-2 mx-3" @click="TestFilter()">
              <font-awesome-icon icon="filter" class="mr-2 fa fa-sm"></font-awesome-icon>{{ t('Filter') }}
            </span>
            <span class="float-right btn btn-light mt-2" @click="clearFilter()" v-if="hasFilter">
              Clear Filter
            </span>
            <h6  class="font-weight-bold" style="padding: 20px 20px 10px 20px">
              {{ title ? title : t('Visitors') }} 
            </h6>

            <input
              class="search-icon form-control w-75 my-3 ml-3"
              @keyup="filterName($event.target.value)"
              :placeholder="t('Filter by name')"
            />            

            <div class="table-responsive d-inline" v-bind:key="visitorDetailKey">
              <table class="table table-hover3">
                <thead>
                  <tr>
                    <th class="text-left pl-4">VISITOR</th>
                    <th class="text-left">DATE</th>
                    <th class="text-center" v-if="!$isOptimize">PAGES</th>
                    <th class="text-center">COUNTRY</th>
                    <th class="text-center">SOURCE</th>
                    <th class="text-left pl-4">DETAILS</th>
                    <th class="text-center" v-if="!$isOptimize">RECORDING</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody v-if="realtimeStatLoaded && visitorData && visitorData.length">
                  <tr v-for="(item, key) in visitorData" v-bind:key="key">                     
                    <td class="my-auto text-muted pl-4 fs-14">
                      <div class="d-flex">
                        <div class="mr-3 my-auto">
                          <img
                            v-if="!item.email"
                            class="d-inline mr-2 profile-picture my-auto mx-auto flag-rounded bg-white"
                            width="40"
                            height="40"
                            :src="
                              'https://api.dicebear.com/5.x/shapes/svg?seed=' + item.uuid
                            "
                          />
                          <img
                            v-else
                            class="d-inline mr-2 profile-picture my-auto mx-auto flag-rounded bg-white"
                            width="40"
                            height="40"
                            :src="
                              'https://www.gravatar.com/avatar/' + item.email_hash + '?s=50'
                            "
                          />    
                        </div>     
                        <div class="my-auto">
                          <span v-if="item.name && item.email"><p class="text-dark font-weight-bold mb-1">{{ item.name }}</p>{{item.email}}</span>
                          <template v-else-if="item.name"><p class="text-dark font-weight-bold mb-1">{{ item.name }}</p></template>
                          <template v-else-if="item.email"><p class="text-dark font-weight-bold mb-1">{{item.email}}</p></template>
                          <template v-else>
                            {{ shorten_last(item.uuid, 8) }}
                          </template>
                        </div>      
                      </div>      
                    </td>

                    <td class="my-auto text-muted fs-14" style="width:100px;">
                      <p class="mb-1 text-dark">{{ $userTimeNow(item.created_at).format('MMM D') }}</p>
                      <span class="text-muted">{{
                        $userTimeNow(item.created_at).format('hh:mm:ss')
                      }}</span>
                    </td>                                                         
                    <td class="my-auto text-muted fs-14 px-0 text-center" v-if="!$isOptimize">
                      {{item.path ? item.path.split('@@@@').length : 0}}
                    </td>                    
                    <td class="text-center">
                      <div class="d-inline">
                        <img v-if="item.country_code && item.country_code !== 'null'" class="d-inline flag-rounded" width="30" height="30" :src="`https://flagicons.lipis.dev/flags/1x1/${item.country_code.toLowerCase()}.svg`" />
                      </div>
                    </td>
                    <td class="my-auto text-center fs-12 text-muted2">
                      <a v-if="item.ref_page" class="d-inline tooltip-pop" :rel="item.ref_page" :href="item.ref_page" target="_blank">
                        <img :src="`https://www.google.com/s2/favicons?sz=64&domain_url=${item.ref_page}`" class="cursor-pointer" width="30" height="30" />
                      </a>
                      <span v-else>
                        {{ shorten_last(processReferrer(item.ref_page), 14) || 'Direct Entry' }}
                      </span>
                    </td>
                    <td style="padding-right: 20px !important" class="pl-4">
                      <IpDeviceInfo class="text-muted d-inline" :ua="item.user_agent" size="28px" /><br>
                      <span v-if="!$isOptimize" class="text-muted fs-12 text-left">{{item.width}}x{{item.height}}</span>
                    </td>
                    <td style="width: 0px" class="text-center" v-if="!$isOptimize">
                      <button v-if="item.has_recording" class="btn btn-blank mr-2 text-muted p-2 tooltip-pop" rel="View recordings" style="border-radius: 50%" type="button" @click="viewRecordings(item.uuid, item.created_at)">
                        <font-awesome-icon icon="video" class="fa fa-sm hovering" />
                      </button>    
                      <span v-else class="mr-2 text-muted p-2" style="border-radius: 50%; border: none !important;">
                        <font-awesome-icon icon="video" class="mt-1 fa fa-sm" style="opacity: 0.25" />
                      </span>
                    </td>
                    <td style="width: 0px">
                      <button @click="showVisitor(item.visitor_id)" class="btn btn-third py-1 mr-4">View Detail</button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else-if="!realtimeStatLoaded && visitors.length">
                  <tr v-for="n in 5" v-bind:key="n">
                    <td v-for="n in 6" v-bind:key="n" class="text-right">
                      <content-placeholders>
                        <content-placeholders-heading :img="true" />
                      </content-placeholders>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="realtimeStatLoaded && (!visitorData || !visitorData.length)" class="text-center pb-4">
                <i>{{ t('No visitors found...') }}</i>
              </div>
            </div>
            <modal name="show-profile" :adaptive="true" 
              height="100%" width="100%" class="full-modal" style="z-index: 10000 !important" 
              @before-open="modalOnOpen" @before-close="modalOnClose">
              <VisitorProfile :visitor_id="visitor_id"></VisitorProfile>
            </modal>
          </div>
        </div>
      </div>
    </div>
    <modal style="z-index: 10000" name="test-filter" class="to-right full-modal" 
    :adaptive="true" width="350px" height="100%" v-on-clickaway="beforeRouteUpdate" @before-close="loadRealtimeData">
      <FilterTest :visitors="visitorsData"></FilterTest>
    </modal>
  </div>
</template>

<script>
const FilterTest = () => import('@/components/FilterTest.vue')
const IpDeviceInfo = () => import('@/components/IpDeviceInfo.vue')

import { store } from '@/store'
import moment from 'moment'
const VisitorProfile = () => import('@/components/VisitorProfile.vue')
import { mixin as clickaway } from 'vue-clickaway'
import 'driver.js/dist/driver.min.css'

/* eslint-disable */
export default {
  store,
  filters: {},
  props: ['visitors', 'title', 'test_id'],
  mixins: [clickaway],
  components: {
    IpDeviceInfo,
    VisitorProfile,
    FilterTest,
  },
  data: function () {
    return {
      initialVisitors: null,
      showFilter: false,
      BrowserFilter: [],
      widgetId: this.$session.get('widget_id'),
      visitorDetailKey: 0,
      visitorsData: [],
      urlParam: [],
      realtimeStatLoaded: false,
      visitor_id: 0,
      key: 0,
      duration: 0,
      uaInfo: {},
      hasFilter: false
    }
  },
  beforeRouteUpdate(to, from, next) {
    // Call the API query method when the URL changes
    setTimeout(() => {
      this.loadRealtimeData()
      this.visitorDetailKey++
      this.key++          
    }, 300);

    next()
  },
  mounted() {
    this.loadRealtimeData()

    this.visitorDetailKey++
    this.key++
  },
  methods: {
    checkUrlParam() {
      this.urlParam = this.$route.query
    },
    filterOnClose() {
      // if (this.$route.query === '') this.$router.replace('/visitor/realtime')
      this.$router.replace({'query': null});

    },
    clearFilter() {
      // this.$router.push({ path: '/visitor/realtime' })
      this.$router.replace({'query': null});

      this.loadRealtimeData()
      this.visitorDetailKey++
      this.key++      
    },
    viewRecordings(id, date) {
      this.$router.push({
        path:'/recordings?visitor_id=' + id, 
        query:{
          startDate: moment(date).format('YYYY-MM-DD'),
        }
      })
    },    
    TestFilter() {
      this.$modal.show('test-filter')
    },
    timeSince: function (time, lang) {
      return moment(time).fromNow()
    },
    dateformat(time){
      return moment(time).format('MMM DD')
    },
    modalOnOpen() {
      document.body.style.overflow = 'hidden'
    },
    modalOnClose(event) {
      document.body.style.overflow = 'auto'
    },
    processReferrer(ref) {
      let originalRef = ref
      try {
        ref = ref.toLowerCase()
      } catch (err) {}
      if (/twclid/.test(ref)) return 'Twitter Ads'
      if (/googleads.g.doubleclick.net/.test(ref)) {
        return 'Google'
      }
      if (/google/.test(ref)) {
        return 'Google'
      }
      if (/facebook/.test(ref) || /fbclid/.test(ref)) {
        return 'Facebook'
      }
      if (/quora/.test(ref)) {
        return 'Quora'
      }
      if (/indiehacker/.test(ref)) {
        return 'Indiehacker'
      }
      if (/yahoo/.test(ref)) {
        return 'Yahoo'
      }
      if (/t.co\//.test(ref)) {
        return 'Twitter'
      }
      if (/linkedin/.test(ref)) {
        return 'Linkedin'
      }
      if (/betalist/.test(ref)) {
        return 'Betalist'
      }
      if (/betapage/.test(ref)) {
        return 'Betapage'
      }
      if (/producthunt/.test(ref)) {
        return 'ProductHunt'
      }
      if (/linkedin/.test(ref)) {
        return 'Linkedin'
      }
      if (ref === '') {
        return 'Direct'
      }
      return typeof originalRef === 'string'
        ? originalRef
            .replace(/www\./, '')
            .replace(/http(s)?\:\/\//, '')
            .split('/')[0]
        : originalRef
    },
    shorten_last(string, len) {
      if (!string) return string

      if (string.length > len) return string.substring(-10, len)
      else return string
    },
    filterName(text){
      this.setUrlParam({ email: text })
    },
    showVisitor(n) {
      this.visitor_id = n
      this.$modal.show('show-profile')
    },
    setUrlParam(obj) {
      // console.log(this.$router.query);

      var query = { ...obj }
      // if (this.$route.query.url) this.pagelocation = this.$route.query.url // read parameter
      //  this.setUrlParam({ landing_page: "www.howuku.com", ref_page: "123" }) // set parameter
      this.$router.replace({ query })
      // if (this.$route.query.url) this.pagelocation = this.$route.query.url
      // console.log(this.urlParam.landing_page);
    },
    loadFilter(data) {
      let visitorData = data
      console.log('load filter')
      console.log(data)
      this.hasFilter = false
      
      if (window.location.search.length !== 0) {
        this.hasFilter = true
        let param_list = {}
        let param = ['visit_page','landing_page','exit_page','os_windows','os_macos','os_linux','os_android','destination','device_desktop','device_mobile','device_tablet','utm_campaign','utm_medium','utm_source','visit_number','source','browser_chrome','browser_safari','browser_firefox','city','country','company_name','name','email']

        console.log(param)

        for (let i = 0; i < param.length; i++) {
          if (this.$route.query[param[i]]) param_list[param[i]] = this.$route.query[param[i]]
        }

        let x = []
        x = data

        let matchesAllCondition = (visitor) => {
          let allow = true

          for (let j in param_list) {
            if (j === 'email') {
              if (!visitor[j].includes(param_list[j])) {
                allow = false
                break
              }
            } else if (j.startsWith('utm_')) {
              if (visitor.property !== null) {
                if (visitor.property[j] !== param_list[j]) {
                  allow = false
                  break
                }
              } else if (visitor.path.includes('utm_')) {
                var url_string = visitor.path
                if (url_string !== null && url_string !== '') {
                  var url = new URL(url_string)
                  var utm_source = url.searchParams.get('utm_source') || ''
                  var utm_medium = url.searchParams.get('utm_medium') || ''
                  var utm_campaign = url.searchParams.get('utm_campaign') || ''
                  if (!utm_source.includes(param_list[j])) {
                    allow = false
                    break
                  }
                  if (!utm_medium.includes(param_list[j])) {
                    allow = false
                    break
                  }
                  if (!utm_campaign.includes(param_list[j])) {
                    allow = false
                    break
                  }
                } else allow = false
              } else if (!visitor.path.includes('utm_')) {
                var ref_string = visitor.ref_page
                if (ref_string !== null && ref_string !== '') {
                  var ref = new URL(ref_string)
                  var utm_source = ref.searchParams.get('utm_source') || ''
                  var utm_medium = ref.searchParams.get('utm_medium') || ''
                  var utm_campaign = ref.searchParams.get('utm_campaign') || ''
                  if (!utm_source.includes(param_list[j])) {
                    allow = false
                    break
                  }
                  if (!utm_medium.includes(param_list[j])) {
                    allow = false
                    break
                  }
                  if (!utm_campaign.includes(param_list[j])) {
                    allow = false
                    break
                  }
                } else allow = false
              } else allow = false
            } else if (j === 'source') {
              if (param_list[j] !== 'Direct') {
                if (!visitor.ref_page.includes(param_list[j])) {
                  allow = false
                  break
                }
              } else if (param_list[j] === 'Direct') {
                if (!(visitor.referrer === '' && visitor.ref_page === '')) {
                  allow = false
                  break
                }
              }
            } else if (j.startsWith('browser_')) {
              this.computeUa(visitor.user_agent)
              if (this.uaInfo.browser !== param_list[j].toLowerCase()) {
                allow = false
                continue
              } else allow = true
              break
            } else if (j.startsWith('os_')) {
              this.computeUa(visitor.user_agent)
              if (j.startsWith('os_')) {
                //  console.log(j)
                if (this.uaInfo.os !== param_list[j].toLowerCase()) {
                  allow = false
                  continue
                } else allow = true
                break
              }
            } else if (j.startsWith('device')) {
              this.computeUa(visitor.user_agent)
              if (this.uaInfo.device !== param_list[j].toLowerCase()) {
                allow = false
                continue
              } else allow = true
              break
            } else if (j === 'visit_number') {
              let visitRange = param_list[j].split('-')
              if (visitRange[0] && visitRange[1]) {
                if (!(visitRange[1] >= visitor.visit_number && visitRange[0] <= visitor.visit_number)) {
                  allow = false
                  break
                }
              } else if (param_list[j] === '1') {
                if (1 !== visitor.visit_number) {
                  allow = false
                  break
                }
              } else if (param_list[j] === '21+') {
                if (!(21 < visitor.visit_number)) {
                  allow = false
                  break
                }
              }
            } else if (j === 'visit_page') {
              if (visitor.path.includes('@@@@')) {
                let pages = visitor.path.split('@@@@')
                if (pages.length > 1) {
                  for (let i = 0; i < pages.length; i++) {
                    if (param_list[j]) {
                      if (!pages[i].includes(param_list[j])) {
                        allow = false
                        continue
                      } else {
                        allow = true
                        break
                      }
                    }
                  }
                } else allow = false
              } else allow = false
            } else if (j === 'exit_page') {
              if (visitor.path.includes('@@@@')) {
                let pages = visitor.path.split('@@@@')

                if (pages.length > 2) {
                  if (!pages[pages.length - 1].includes(param_list[j])) {
                    allow = false
                    break
                  }
                }
              } else allow = false
            } else if (j === 'landing_page') {
              let pages = visitor.path.split('@@@@')
              if (!pages[0].includes(param_list[j])) {
                allow = false
                break
              }
            } else if (visitor[j] !== param_list[j]) {
              allow = false
              break
            }
          }

          //  console.log("final status", allow);
          return allow
        }

        visitorData = x.filter(matchesAllCondition)

        function filterByCountry(item) {
          if (item.country === param_list['country']) {
            return true
          } else return false
        }
        if (param_list['country'])
          visitorData = visitorData.filter(filterByCountry)
      }
      this.visitorData = visitorData

      setTimeout(() => {
        this.visitorDetailKey++
        this.key++    
      }, 300);
    },
    computeUa(val) {
      var ua = val,
        browser = /Edge\/\d+/.test(ua)? 'edge': /MSIE 9/.test(ua)? 'internet-explorer': /MSIE 10/.test(ua)? 'internet-explorer': /MSIE 11/.test(ua)? 'internet-explorer': /MSIE\s\d/.test(ua)? 'internet-explorer': /rv\:11/.test(ua)? 'internet-explorer': /Firefox\W\d/.test(ua)? 'Firefox': /Chrome\W\d/.test(ua)? 'chrome': /Chromium\W\d/.test(ua)? 'chrome': /\bSafari\W\d/.test(ua)? 'safari': /\bOpera\W\d/.test(ua)? 'opera': /\bOPR\W\d/i.test(ua)? 'chrome': typeof MSPointerEvent !== 'undefined'? 'internet-explorer': 'chrome',
        os = /Windows NT 10/.test(ua)? 'windows': /Windows NT 6\.0/.test(ua)? 'windows': /Windows NT 6\.1/.test(ua)? 'windows': /Windows NT 6\.\d/.test(ua)? 'windows': /Windows NT 5\.1/.test(ua)? 'windows': /Windows NT [1-5]\./.test(ua)? 'windows': /Mac/.test(ua)? 'apple': /Linux/.test(ua)? 'linux': /X11/.test(ua)? 'linux': '',
        mobile = /IEMobile|Windows Phone|Lumia/i.test(ua)? 1: /iPhone|iP[oa]d/.test(ua)? 1: /Android/.test(ua)? 1: /BlackBerry|PlayBook|BB10/.test(ua)? 1: /Mobile Safari/.test(ua)? 1: /webOS|Mobile|Tablet|Opera Mini|\bCrMo\/|Opera Mobi/i.test(ua)? 1: 0,
        tablet = /Tablet|iPad/i.test(ua)

      this.uaInfo.browser = browser
      this.uaInfo.device = mobile ? 'mobile-alt' : tablet ? 'tablet-alt' : 'desktop'
      this.uaInfo.os = (mobile || tablet) && os === 'apple' ? 'iOS' : (mobile || tablet) && os === 'linux' ? 'android' : os
    },
    async loadRealtimeData() {
      if (this.visitors && this.visitors.length) {
        let visitor_id = JSON.stringify(this.visitors)
        try {
          let result = await this.$http.post(process.env.API_ENDPOINT + '/dashboard/visitors/' + this.widgetId, { 
            visitor_id: visitor_id,
            test_id: this.test_id
          })
          this.initialVisitors = result.data

          // get ab data
          this.realtimeStatLoaded = true
        } catch(e){
          this.realtimeStatLoaded = true
        }
      } else {
        this.realtimeStatLoaded = true
      }

      // if (!this.initialVisitors) {        
      //   try {
      //     let result = await this.$http.get(process.env.API_ENDPOINT + '/dashboard/visitors/' + this.widgetId)
      //     this.initialVisitors = result.data
      //     this.realtimeStatLoaded = true
      //   } catch(e){
      //     this.realtimeStatLoaded = true
      //   }
      // }

      this.loadFilter(this.initialVisitors)
    },
  },
}
</script>

<style>
.side-highlight {
  border-left: 1px dashed #d5d5d5;
  /* padding-left: 8px; */
  padding-left: 12px;
  margin-left: 0px;
  margin-top: 4px;
  font-size: 90%;
}
</style>


// WEBPACK FOOTER //
// src/pages/VisitorRealtime.vue